import React from "react";

/* BrandMark — MASTER_SPEC Draft80 §4.8 (BRAND-01).
 *
 * The crowned bee is the owner's asset and is used as supplied: the SVG
 * master below is a VTracer path conversion of her supplied art (two-tone
 * gold + black paths, no redrawing or recolouring), chosen by the owner as
 * the canonical master. PNG variants generated from her transparent master
 * remain in brand/ as fallback and are not referenced by this component.
 *
 * The mark never appears on printable postcard artwork — that boundary lives
 * in carecard/print_layout.py and is tested there.
 */

const SIZES = { sm: 32, md: 40, lg: 56 };

const BRAND_SRC = "/brand/crowned-bee.svg";

export function BrandMark({ size = "md", withWordmark = true, tagline = false, taglineText = "A Message That Matters.", className = "" }) {
  const px = SIZES[size] || SIZES.md;
  return (
    <span className={`cc-brand cc-brand-${size} ${className}`.trim()}>
      <img
        src={BRAND_SRC}
        width={px}
        height={px}
        alt=""
        aria-hidden="true"
        className="cc-brand-mark"
        decoding="async"
      />
      {withWordmark && (
        <span className="cc-brand-text" aria-hidden="true">
          <span className="cc-brand-word">CareCard Express</span>
          {tagline && <span className="cc-brand-tagline">{taglineText}</span>}
        </span>
      )}
      {/* The image is decorative; the accessible name comes from the wordmark.
          The wordmark can also be hidden by CSS on narrow screens, so the
          screen-reader name is always present rather than conditional. */}
      <span className="cc-sr-only">CareCard Express</span>
    </span>
  );
}

export default BrandMark;

/* FlagshipLockup — BUILD-22 §20.22.
 *
 * The owner-approved flagship CareCard Express lockup (variant E, her
 * 2026-10-11 choice): crown + wordmark, gold on black. The raster is used
 * exactly as supplied — proportional resize only, never redrawn, traced,
 * recolored, stretched, or reconstructed in CSS. Canonical source:
 * /brand/carecard-logo-e7-flagship.png (promoted from the owner's flagship
 * file per BUILD-22). Use for the full-wordmark role (about page, splash,
 * share imagery); the crowned-bee mark remains the icon role.
 */
const FLAGSHIP_SRC = "/brand/carecard-logo-e7-flagship.png";

export function FlagshipLockup({ width = 320, className = "" }) {
  return (
    <span className={`cc-flagship ${className}`.trim()}>
      <img
        src={FLAGSHIP_SRC}
        width={width}
        alt=""
        aria-hidden="true"
        className="cc-flagship-lockup"
        decoding="async"
      />
      <span className="cc-sr-only">CareCard Express</span>
    </span>
  );
}
